import Button from '@hubins/components/Button';
import Heading from '@hubins/components/Heading';
import Icon from '@hubins/components/IconNew';
import Modal from '@hubins/components/Modal';
import Wrapper from '@hubins/components/Wrapper';
import { Column, Columns } from 'components/Columns';
import __, { __route } from 'localisation';
import React from 'react';
import './index.scss';

const sources = [
  {
    title: 'Överskott lön',
    icon: 'check payment sign',
    type: 'salary',
  },
  {
    title: 'Utdelning',
    icon: 'cash payment coins',
    type: 'dividend',
  },
  {
    title: 'Ägande i eller försäljning av fastighet',
    icon: 'real estate insurance dollar hand',
    type: 'property',
  },
  {
    title: 'Ägande i eller försäljning av företag',
    icon: 'real estate action building dollar',
    type: 'sale_company',
  },
  {
    title: 'Arv, gåvor eller Annat',
    icon: 'Single Neutral Actions Money by Streamlinehq',
    type: 'inheritance_gift',
  },
  {
    title: 'Lån',
    icon: 'cash payment bag',
    type: 'loan',
  },
  {
    title: 'Investeringar',
    icon: 'Performance Money Increase',
    type: 'profits_investment',
  },
];

const companySources = [
  {
    title: 'Resultat från daglig verksamhet',
    icon: 'check payment sign',
    type: 'company_profits',
  },
  {
    title: 'Investeringar',
    icon: 'cash payment coins',
    type: 'profits_investment',
  },
  {
    title: 'Ägande i eller försäljning av fastighet',
    icon: 'real estate insurance dollar hand',
    type: 'property',
  },
  {
    title: 'Ägande i eller försäljning av andra företag',
    icon: 'real estate action building dollar',
    type: 'sale_company',
  },
  {
    title: 'Utdelning',
    icon: 'Common File Text by Streamlinehq',
    type: 'dividend',
  },
  {
    title: 'Annat',
    icon: 'Common File Text by Streamlinehq',
    type: 'company_other',
  },
  {
    title: 'Aktieemission',
    icon: 'cash payment bag',
    type: 'issue_stock',
  },
  {
    title: 'Lån',
    icon: 'Cash Payment Bag 1',
    type: 'loan',
  },
  {
    title: 'Finansiering från moderbolag ',
    icon: 'Cash Payment Bills',
    type: 'company_financing',
  },
];

const SourceButton = ({ title, icon, type, portfolioUuid, profileUuid, backoffice }) => {
  const getUrl = () => {
    if (backoffice) {
      return `/sof/create/${type}/${profileUuid}`;
    }
    return `${__route('sof')}/${portfolioUuid}/${type}`;
  };

  const url = getUrl();

  return (
    <div className="source_button">
      <div className="s-bottom-xl">
        <Icon icon={icon} size={24} color="primary" />
        <Heading size="5" className="flex-center--horizontal space-between">
          {title}
        </Heading>
      </div>
      <div>
        <Button href={url} className="secondary s-top-xl" icon="add" iconColor="primary">
          Lägg till
        </Button>
      </div>
    </div>
  );
};

const AddSourceModal = ({
  open,
  premium,
  callback,
  portfolioUuid,
  registration,
  profileUuid,
  isCompany,
  backoffice,
}) => {
  const baseSources = isCompany ? companySources : sources;
  const theSources = baseSources;

  return (
    <Modal closeButton shouldCloseOnOverlayClick open={open} callback={callback}>
      <Wrapper>
        <Columns>
          <Column s="12">
            <Heading size="3" className="s-bottom-l">
              Lägg till ny källa
            </Heading>
          </Column>
          {theSources.map((source) => (
            <Column xs="12" s="6" m="6" l="4" key={`source_button-${source.type}`}>
              <SourceButton
                title={source.title}
                icon={source.icon}
                premium={premium}
                type={source.type}
                portfolioUuid={portfolioUuid}
                registration={registration}
                profileUuid={profileUuid}
                isCompany={isCompany}
                backoffice={backoffice}
              />
            </Column>
          ))}
        </Columns>
      </Wrapper>
    </Modal>
  );
};

export default AddSourceModal;
